// extracted by mini-css-extract-plugin
export var breadcrumb = "_17-2";
export var breadcrumbArrow = "_17-3";
export var breadcrumbs = "_17-0";
export var link = "_17-4";
export var small = "_17-1";